import React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from '../../utils/cn';

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium',
  {
    variants: {
      variant: {
        default: 'bg-gray-700 text-gray-100',
        secondary: 'bg-gray-600 text-gray-100',
        destructive: 'bg-error-600 text-white',
        outline: 'border border-gray-600 text-gray-100',
        success: 'bg-success-600 text-white',
        warning: 'bg-warning-600 text-white',
        info: 'bg-info-600 text-white',
        // Subscription plan badges
        free: 'bg-gray-600 text-white',
        starter: 'bg-info-600 text-white',
        creator: 'bg-purple-600 text-white',
        pro: 'bg-warning-600 text-white',
        studio: 'bg-error-600 text-white',
        // Status badges
        active: 'bg-success-600 text-white',
        inactive: 'bg-gray-600 text-white',
        suspended: 'bg-error-600 text-white',
        banned: 'bg-error-700 text-white',
        // Platform admin (Firebase `admin` claim)
        admin: 'bg-purple-600 text-white',
        // Credit operation badges
        grant: 'bg-success-600 text-white',
        deduct: 'bg-error-600 text-white',
        set: 'bg-info-600 text-white',
        refund: 'bg-success-600 text-white',
        // Severity badges
        low: 'bg-success-100 text-success-800 border border-success-200',
        medium: 'bg-warning-100 text-warning-800 border border-warning-200',
        high: 'bg-error-100 text-error-800 border border-error-200',
        critical: 'bg-error-200 text-error-900 border border-error-300',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);

export interface BadgeProps
  extends
    React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge, badgeVariants };
